import type { Message, ToolCall } from '~/hooks/use-chat/types';

import { Markdown } from './markdown';
import { DynamicForm } from './tools/dynamic-form';
import { TableForm } from './tools/table-form';

interface MessageContentProps {
  message: Message;
  handleAction: (action: ToolCall, response: string) => Promise<void>;
  isActive: boolean;
}

export function MessageContent({
  message,
  handleAction,
  isActive,
}: MessageContentProps) {
  if (!message.tool_calls) {
    return message.type === 'tool' ? (
      <p>Formulario enviado</p>
    ) : (
      <Markdown>{message.content}</Markdown>
    );
  }

  const renderToolCall = (toolCall: ToolCall, idx: number) => {
    switch (toolCall.name) {
      case 'human_input':
        return (
          <DynamicForm
            key={toolCall.id ?? idx}
            // biome-ignore lint/suspicious/noExplicitAny: toolCall type varies by implementation
            toolCall={toolCall as any}
            handleAction={handleAction}
            isActive={isActive}
          />
        );
      case 'table_form':
        return (
          <TableForm
            key={toolCall.id ?? idx}
            // biome-ignore lint/suspicious/noExplicitAny: toolCall type varies by implementation
            toolCall={toolCall as any}
            handleAction={handleAction}
            isActive={isActive}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col gap-2 min-w-0 overflow-hidden">
      {message.content && <Markdown>{message.content}</Markdown>}
      {message.tool_calls.map(renderToolCall)}
    </div>
  );
}
